import { BaseXform } from "@excel/xlsx/xform/base-xform";

interface HyperlinkModel {
  address: string;
  rId?: string;
  tooltip?: string;
  target?: string;
}

class HyperlinkXform extends BaseXform {
  get tag(): string {
    return "hyperlink";
  }

  render(xmlStream: any, model: HyperlinkModel): void {
    if (model.target && isInternalLink(model.target)) {
      // Internal link: use location attribute only (no relationship)
      // Strip the leading "#" — OOXML location attribute is without "#"
      xmlStream.leafNode("hyperlink", {
        ref: model.address,
        tooltip: model.tooltip,
        location: model.target.slice(1)
      });
    } else {
      // External link: use r:id relationship reference
      xmlStream.leafNode("hyperlink", {
        ref: model.address,
        "r:id": model.rId,
        tooltip: model.tooltip
      });
    }
  }

  parseOpen(node: any): boolean {
    if (node.name === "hyperlink") {
      this.model = {
        address: node.attributes.ref,
        rId: node.attributes["r:id"],
        tooltip: node.attributes.tooltip
      };

      // Internal link: location attribute stores the target without "#"
      // Normalize: always store as "#Location" in the model regardless of
      // whether the source had a leading "#" (our old buggy output) or not
      // (correct OOXML from Excel or the fixed writer).
      if (node.attributes.location) {
        const loc = node.attributes.location;
        this.model.target = loc.startsWith("#") ? loc : `#${loc}`;
      }
      return true;
    }
    return false;
  }

  parseText(): void {}

  parseClose(): boolean {
    return false;
  }
}

/**
 * Internal hyperlinks start with "#" (e.g. "#Sheet2!A1").
 * This matches Excel's convention and the OOXML spec where internal links
 * use the `location` attribute instead of a relationship.
 */
function isInternalLink(target: string): boolean {
  return target.startsWith("#");
}

export { HyperlinkXform, isInternalLink };
